import { OfficialDocuments } from '../../../redux/config'
import { DeliveryOption, DeliveryOptionLabelRenderer } from '../../../pages/utils/config'
import { CompanyDetail } from '../../../redux/companyDetail/types'
import { Dictionary } from '../../../utils/types'
import { PreferredProductsResponse } from '../../../hooks/usePreferredProducts'

export enum ReportType {
  Online = 'ONLINE',
  Offline = 'OFFLINE'
}

export type Report = {
  type: ReportType
  bifName: string
  orderingName: string | undefined
  code: string
  languages: string[]
  deliveryOptions: DeliveryOption[]
  lastUpdateDate?: string
  consentRequired?: boolean
  materialTypePriceParam?: string
  countryCodePriceParam?: string
  isFinancialPriceParam?: string
  inRevisionPriceParam?: string
  dataTypePriceParam?: string
  documentDates?: Dictionary<string>
  providerName?: string
  providerCode?: string
  proofsOfInterest?: string[]
}

export type CompanyDetailReportsProps = {
  reports: Report[]
  companyIdentifier: string
  companyDetail?: CompanyDetail
  requireConsent?: boolean
  renderDeliveryOptionLabel: DeliveryOptionLabelRenderer
  officialDocumentsConfig?: OfficialDocuments
  showPriceForAnonymousUsers?: boolean
  preferredProductsData: PreferredProductsResponse | undefined
  refreshPreferredProductsData: () => void
  loadingPreferredProducts: boolean
}

export type ReportFormValues = {
  parentLanguage: string
  parentDeliveryOption: string
  childLanguage: string
  childDeliveryOption: string
  mode: 'AddToCart' | 'BuyNow'
  selectedReportIndex: number
  acceptedConsent?: string
  documentVersion?: string
  parentProofOfInterest?: string
  childProofOfInterest?: string
}
